@if (modeStrategy.inputMode | async; as inputMode) {
    @if (error) {
        <ms-numpad-error [error]="error" />
    }
    @if (inputMode === StakeInputMode.Field) {
        <ms-numpad-host [id]="keypadId" />
    }
}
